import { Button, message, Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useClickOutside } from '../../../../hooks/useClickOutSide';
import copyImage from '../../../../assets/copyImage.svg';
import calendar from '../../../../assets/calendar-chedule.svg';
import Reschedule from '../../../../assets/Reschedule.png';
import arrow from '../../../../assets/arrow.svg';

import calendarImage from '../../../../assets/Calendar, Schedule, Clock.svg';
import stopImage from '../../../../assets/stopImage.svg';
import UserIcon from '../../../../assets/ManualyAddedSuppliers.png';

import moment from 'moment';
import { ClockIcon } from '../../../Icons/ClockIcon';
import { CalendarSvg } from '../../../Icons/CalendarIcon';
import Delete from '../../../Icons/Delete';
import { DeleteModal } from './DeleteModal';
import RoleImage from '../../../../assets/RoleImage.svg';
import Visit from '../../../../assets/Visit.svg';
import { useNavigate } from 'react-router-dom';
import { downloadFunc } from '../../features';
import ReceivedFile from '../../../../assets/ReceivedFile.svg';
import { ReschedulePitchModal } from '../../../Modals/ReschedulePitchModal';
import { RejectSupplierModalOnEvaluate2 } from '../../../Modals/RejectSupplierModalOnEvaluate2';
import { RejectIncumbentSupplier } from '../../../Modals/RejectIncumbentSupplier';
import { Loader } from '../../../Loader/Loader';
import done from '../../../../assets/Done, Check.svg';
import { useShortlistSupplierMutation } from '../../../../api/tenders';

const noScores = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3333 15H4.16667C3.24583 15 2.5 14.2542 2.5 13.3333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H13.3333C14.2542 2.5 15 3.24583 15 4.16667V13.3333C15 14.2542 14.2542 15 13.3333 15Z"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.72259 9.58596V9.41346C8.72259 8.84846 9.07175 8.54263 9.42175 8.30763C9.76342 8.07763 10.1059 7.77763 10.1059 7.2243C10.1059 6.46013 9.48675 5.8418 8.72342 5.8418C7.96009 5.8418 7.34009 6.4593 7.34009 7.22346"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.72175 11.5358C8.65258 11.5358 8.59675 11.5916 8.59758 11.6608C8.59758 11.73 8.65341 11.7858 8.72258 11.7858C8.79175 11.7858 8.84758 11.73 8.84758 11.6608C8.84758 11.5916 8.79175 11.5358 8.72175 11.5358"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15 5H15.8333C16.7542 5 17.5 5.74583 17.5 6.66667V15.8333C17.5 16.7542 16.7542 17.5 15.8333 17.5H6.66667C5.74583 17.5 5 16.7542 5 15.8333V15"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

const dots = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M9.99762 14.5859C9.76835 14.5859 9.58078 14.7735 9.58328 15.0028C9.58328 15.232 9.77085 15.4196 10.0001 15.4196C10.2294 15.4196 10.417 15.232 10.417 15.0028C10.417 14.7735 10.2294 14.5859 9.99762 14.5859"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.99762 9.58398C9.76835 9.58398 9.58078 9.77156 9.58328 10.0008C9.58328 10.2301 9.77085 10.4177 10.0001 10.4177C10.2294 10.4177 10.417 10.2301 10.417 10.0008C10.417 9.77156 10.2294 9.58398 9.99762 9.58398"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.99762 4.58203C9.76835 4.58203 9.58078 4.76961 9.58328 4.99887C9.58328 5.22813 9.77085 5.41571 10.0001 5.41571C10.2294 5.41571 10.417 5.22813 10.417 4.99887C10.417 4.76961 10.2294 4.58203 9.99762 4.58203"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const SupplierEvaluate2SU = ({ item, setTrigger, data }: any) => {
    const [openManage, setOpenManage] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);
    useClickOutside(ref, () => setOpenManage(false));
    const [shortlist, { data: shortlistData, isSuccess, isLoading: isLoadingShortList }] =
        useShortlistSupplierMutation();
    const navigate = useNavigate();
    const [deleteUserModal, setDeleteUserModal] = useState<any | null>(null);
    const [rescheduleModal, setRescheduleModal] = useState(false);

    const [isRejectIncumbentModal, setIsRejectIncumbentModal] = useState(false);
    const [rejectSupplierModal, setRejectSupplierModal] = useState(false);

    const [openDetails, setOpenDetails] = useState(false);

    const addedByBuyer = item.added_by_buyer;
    const pitchSlot = item?.pitch?.assigned_slot;
    const isRejectedSlot = item?.pitch?.status === 'declined' && item?.pitch?.decline_reason;
    const isRescheduledSlot = item?.pitch?.status === 'slots_request' && item?.pitch?.decline_reason;

    const users = item?.score_card_responses;

    const participants = item.pitch?.participants;

    useEffect(() => {
        if (isSuccess) {
            setTrigger((prev: boolean) => !prev);
            message?.success(shortlistData?.message);
        }
    }, [isSuccess]);

    const shortlistFunc = async (id: number) => {
        try {
            const dataToPost = {
                tenderId: data.id,
                supplierId: id
            };
            shortlist(dataToPost);
        } catch {}
    };

    return (
        <>
            <div
                className={`supplier-card SU ${item.status === 'shortlisted' ? 'completed' : ''} ${
                    item.status === 'rejected' ? 'rejected' : ''
                }`}
            >
                <div className={`supplier-card__content `}>
                    <div className="supplier-card__header">
                        <div className="supplier-card__info">
                            <div className="supplier-card__badge-wrapper">
                                {addedByBuyer && <div className="supplier-card__added">Added by buyer</div>}
                                {item.incumbent && <div className="supplier-card__badge">Incumbent Supplier</div>}
                            </div>
                            <div className="supplier-card__name">
                                <div className="title">{item.name}</div>
                                <div className="subtitle">{item?.trading_name}</div>
                            </div>
                        </div>
                        <div className="supplier-card__btns">
                            <div ref={ref} style={{ position: 'relative' }}>
                                <div className="supplier-card__dots" onClick={() => setOpenManage((prev) => !prev)}>
                                    {dots}
                                </div>
                                {openManage && (
                                    <div className="head__openManage openManage manageSupplierCard">
                                        <div
                                            className="openManage__item"
                                            onClick={async () => {
                                                const token = item.score_card_token;
                                                if (!token) {
                                                    message.warning('No scorecard link available');
                                                    return;
                                                }
                                                const url = `${
                                                    window.location.origin
                                                }/supplier-company/score-card?token=${encodeURIComponent(token)}`;
                                                try {
                                                    await navigator.clipboard.writeText(url);
                                                    message.success('Scorecard link copied to clipboard');
                                                    setOpenManage(false);
                                                } catch {
                                                    message.error('Could not copy link');
                                                }
                                            }}
                                        >
                                            <img src={copyImage} />
                                            Copy Scorecard Link
                                        </div>
                                    </div>
                                )}
                            </div>
                            {item.status === 'rejected' ? (
                                <div className="task__btn-wrap" style={{ margin: '0 12px 0 0' }}>
                                    <div className="task__declined-active">
                                        <img src={stopImage} />
                                        Excluded from Evaluation
                                    </div>
                                </div>
                            ) : (
                                <Button
                                    style={{ margin: '0 12px 0 0' }}
                                    onClick={() => {
                                        if (item.incumbent) {
                                            setIsRejectIncumbentModal(true);
                                        } else {
                                            setRejectSupplierModal(true);
                                        }
                                    }}
                                >
                                    Exclude from Evaluation
                                </Button>
                            )}
                            {item.status === 'shortlisted' ? (
                                <div className="task-complete__title-row">
                                    <div className="task-complete__approved-active">
                                        <img src={done} />
                                        Completed
                                    </div>
                                </div>
                            ) : (
                                <Tooltip
                                    title={
                                        !users?.length
                                            ? 'To mark the scorecard as complete, at least one person must complete their scorecard'
                                            : isRejectedSlot
                                            ? 'Supplier has withdrawn their partcipation'
                                            : ''
                                    }
                                    overlayClassName={
                                        !users?.length || isRejectedSlot ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                    }
                                >
                                    <span style={{ display: 'inline-block' }}>
                                        <Button
                                            className="blue-btn"
                                            style={{ margin: '0 12px 0 0' }}
                                            disabled={!users?.length || isRejectedSlot}
                                            onClick={() => shortlistFunc(item.id)}
                                        >
                                            {isLoadingShortList ? <Loader /> : 'Mark as Complete'}
                                        </Button>
                                    </span>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    <div className="supplier-card__block">
                        <div className="supplier-card__block-wrapper">
                            {isRescheduledSlot ? (
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Pitch Date & Time</span>
                                        <div className="slot-value orange">
                                            <CalendarSvg fill="#E64A0D" className={''} />
                                            New Slot Requested
                                        </div>
                                    </div>
                                </div>
                            ) : isRejectedSlot ? (
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Pitch Date & Time</span>
                                        <div className="slot-value error">
                                            <img src={stopImage} alt="calendar" />
                                            Participation Withdrawn
                                        </div>
                                    </div>
                                </div>
                            ) : pitchSlot ? (
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Pitch Date</span>
                                        <div className="slot-value">
                                            <img src={calendar} alt="calendar" />
                                            {moment(pitchSlot?.date)?.format('YYYY-MM-DD')}
                                        </div>
                                    </div>
                                    <div className="slot-block">
                                        <span className="slot-label">Time</span>
                                        <div className="slot-value">
                                            <ClockIcon fill="#001965" />
                                            {pitchSlot?.time_from} - {pitchSlot?.time_to}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Pitch Date & Time</span>
                                        <div className="slot-value">
                                            <img src={calendarImage} alt="calendar" />
                                            Not Specified Yet
                                        </div>
                                    </div>
                                </div>
                            )}
                            {item.pitch?.status === 'reschedule' ? (
                                <div className="supplier-card__rescheduled">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M16.6666 5.41602L7.49992 14.5827L3.33325 10.416"
                                            stroke="#001965"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>{' '}
                                    Rescheduled
                                </div>
                            ) : (
                                item?.pitch && (
                                    <Button
                                        onClick={() => {
                                            setRescheduleModal(true);
                                        }}
                                        className="supplier-card__btn-white"
                                    >
                                        <img src={Reschedule} /> Reschedule
                                    </Button>
                                )
                            )}
                        </div>
                        {(isRejectedSlot || isRescheduledSlot) && (
                            <div className="slot-comment">
                                <h1>My Comment</h1>
                                <span>{item?.pitch?.decline_reason}</span>
                            </div>
                        )}
                    </div>
                    {users?.length > 0 ? (
                        <div className="supplier-card__block">
                            <div className="supplier-card__block-wrapper">
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Completed Scorecard</span>
                                        <div className="users-list">
                                            {users?.map((user: any, index: number) => (
                                                <div key={user.id} className="users-list__item">
                                                    <div className="users-list__info">
                                                        <img src={UserIcon} className="users-list__icon" />
                                                        <span>{user.user_name}</span>
                                                        <Delete
                                                            className="users-list__delete"
                                                            onClick={() => setDeleteUserModal(user)}
                                                            fill="#001965"
                                                        />
                                                    </div>
                                                    {index < users.length - 1 && (
                                                        <div className="users-list__divider" />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="supplier-card__block">
                            <div className="supplier-card__block-wrapper">
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Completed Scorecard</span>
                                        <div className="slot-value">{noScores} No scores received yet</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {openDetails ? (
                        <div className="supplier-card__show" onClick={() => setOpenDetails(false)}>
                            Hide Details <img src={arrow} style={{ transform: 'rotate(180deg)' }} />
                        </div>
                    ) : (
                        <div
                            className="supplier-card__show"
                            onClick={() => setOpenDetails(true)}
                            style={{ border: 'none' }}
                        >
                            Show Details <img src={arrow} />
                        </div>
                    )}
                    {openDetails && (
                        <div className="supplier-card__block">
                            <div className="supplier-card__block-wrapper">
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Supplier Pitch Presentation</span>
                                        {item?.pitch?.presentation_file ? (
                                            <div
                                                className="supplier-SU__white-btn"
                                                onClick={() => {
                                                    downloadFunc(item?.pitch?.presentation_file?.uuid);
                                                }}
                                            >
                                                View Presentation <img src={Visit} />
                                            </div>
                                        ) : (
                                            <div className="slot-value">
                                                <img src={ReceivedFile} />
                                                Not Provided
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>{' '}
                            <div className="supplier-card__block-wrapper">
                                <div className="slots-wrapper">
                                    <div className="slot-block">
                                        <span className="slot-label">Participants</span>
                                        {participants?.length ? (
                                            <div className="participants">
                                                {participants.map((user: any, index: number) => (
                                                    <>
                                                        <div key={user.id} className="participant">
                                                            <span className="participant__name">{user.name}</span>
                                                            <span className="participant__role">{user.title}</span>
                                                        </div>
                                                        {index < users.length - 1 && (
                                                            <div className="participants__divider" />
                                                        )}
                                                    </>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="slot-value">
                                                <img src={RoleImage} />
                                                Not Specified
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {deleteUserModal && (
                <DeleteModal
                    data={deleteUserModal}
                    setOpenModal={setDeleteUserModal}
                    tenderId={data?.id}
                    setTrigger={setTrigger}
                />
            )}

            {rescheduleModal && (
                <ReschedulePitchModal
                    openModal={rescheduleModal}
                    setOpenModal={setRescheduleModal}
                    setTrigger={setTrigger}
                    data={data}
                    supplierId={item?.id}
                    pitchId={item?.pitch?.id}
                />
            )}
            {rejectSupplierModal && (
                <RejectSupplierModalOnEvaluate2
                    openModal={rejectSupplierModal}
                    setOpenModal={setRejectSupplierModal}
                    setTrigger={setTrigger}
                    data={data}
                    selectedSupplier={item}
                />
            )}
            {isRejectIncumbentModal && (
                <RejectIncumbentSupplier
                    openModal={isRejectIncumbentModal}
                    setOpenModal={setIsRejectIncumbentModal}
                    setTrigger={setTrigger}
                    selectedSupplier={item}
                    data={data}
                    taskId={data?.phase_tasks?.find((elem: any) => elem.action === 'evaluate_3_suppliers')?.id}
                    setIsRejectModal={setRejectSupplierModal}
                />
            )}
        </>
    );
};
